import PropTypes from 'prop-types'
import locationIcon from '../../../../assets/img/location-icon.svg'
import calendarIcon from '../../../../assets/img/calendar-icon.svg'
import {
  ClockIcon,
  CheckCircleIcon,
  CancelIcon,
  TrophySmallIcon,
  TrophyOutlineIcon,
} from '../../../../assets/svg'
import { REQUEST_STATUSES } from '../../../../assets/const'

const STATUS_META = {
  [REQUEST_STATUSES.SUBMITTED]: { label: 'Подана', bg: '#f3f4f6', color: '#475569', Icon: ClockIcon },
  [REQUEST_STATUSES.APPROVED]: { label: 'Одобрена', bg: '#d1fada', color: '#228b51', Icon: CheckCircleIcon },
  [REQUEST_STATUSES.REJECTED]: { label: 'Отклонена', bg: '#fee2e2', color: '#dc2626', Icon: CancelIcon },
  [REQUEST_STATUSES.COMPLETED]: { label: 'Завершено', bg: '#f3f4f6', color: '#475569', Icon: TrophySmallIcon },
  [REQUEST_STATUSES.WITHDRAWN]: { label: 'Отозвана', bg: '#fee2e2', color: '#dc2626', Icon: CancelIcon },
}

const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status]
  if (!meta) return null
  const { label, bg, color, Icon } = meta
  return (
    <span
      className="flex items-center gap-[5px] whitespace-nowrap rounded-[50px] px-[0.75rem] sm:px-[1rem] py-[0.375rem] sm:py-[0.5rem] text-[0.812rem] sm:text-[1rem] font-medium leading-[1.25rem]"
      style={{ backgroundColor: bg, color }}
    >
      <Icon />
      {label}
    </span>
  )
}

const RequestCard = ({ title, location, dates, result, submittedAt, status, onDetailsClick }) => {
  return (
  <article className="flex w-full sm:w-[calc(50%-0.625rem)] xl:w-[42.625rem] flex-col gap-[1.5rem] sm:gap-[2rem] rounded-[20px] border border-solid border-[#d9d9d9] bg-white p-[1.25rem] sm:p-[1.5rem] lg:p-[2rem]">
    <div className="flex w-full flex-col gap-[1.25rem]">
      <div className="flex flex-col gap-[0.75rem] sm:flex-row sm:items-start sm:justify-between sm:gap-[1.25rem]">
        <h3 className="m-0 text-[1.125rem] sm:text-[1.25rem] lg:text-[1.5rem] font-semibold leading-[1.4] lg:leading-[1.82rem] text-[#111827] break-words flex-1 min-w-0">
          {title}
        </h3>
        <div className="self-start">
          <StatusBadge status={status} />
        </div>
      </div>
      <div className="flex flex-col gap-[0.375rem] text-[0.875rem] sm:text-[1rem] text-[#6b7280]">
        {location && (
          <div className="flex items-center gap-[0.625rem]">
            <img className="h-[1.125rem] w-[1.125rem] sm:h-[1.25rem] sm:w-[1.25rem] shrink-0" alt="" src={locationIcon} />
            <span className="leading-[1.625rem] break-words">{location}</span>
          </div>
        )}
        {dates && (
          <div className="flex items-center gap-[0.625rem]">
            <img className="h-[1.125rem] w-[1.125rem] sm:h-[1.25rem] sm:w-[1.25rem] shrink-0" alt="" src={calendarIcon} />
            <span className="leading-[1.625rem] break-words">{dates}</span>
          </div>
        )}
      </div>
    </div>

    <div className="flex items-start gap-[0.625rem] text-[0.875rem] sm:text-[1rem]">
      <span className="shrink-0 mt-[0.125rem]"><TrophyOutlineIcon /></span>
      <div className="flex flex-wrap gap-x-[0.5rem]">
        <span className="text-[#848484] leading-[1.5rem]">Результат:</span>
        <span className="text-[#374151] leading-[1.5rem]">{result}</span>
      </div>
    </div>

    <div className="flex w-full flex-col sm:flex-row sm:items-center sm:justify-between gap-[0.5rem] text-[0.875rem] sm:text-[1rem]">
      <div className="flex flex-wrap items-center gap-[0.312rem] text-[#848484]">
        <span>Дата подачи заявки:</span>
        <span className="font-medium">{submittedAt}</span>
      </div>
      <button
        type="button"
        onClick={onDetailsClick}
        className="cursor-pointer border-0 bg-transparent p-0 text-[#475569] underline self-start sm:self-auto"
      >
        Детали заявки
      </button>
    </div>
  </article>
)
}

RequestCard.propTypes = {
  title: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  dates: PropTypes.string.isRequired,
  result: PropTypes.string.isRequired,
  submittedAt: PropTypes.string.isRequired,
  status: PropTypes.oneOf(Object.values(REQUEST_STATUSES)).isRequired,
  onDetailsClick: PropTypes.func,
}

export default RequestCard
